import { Config } from 'core/common/contexts';
import { ConsolaLogger, HttpClientBuilder } from 'core/common/services';
import { HttpFunnelService } from '../services';

type FunnelServiceOptions = {
  shouldRetry: boolean;
};

export class FunnelServiceBuilder {
  static create(config: Config, { shouldRetry }: FunnelServiceOptions = { shouldRetry: true }) {
    const loggingService = new ConsolaLogger();

    const httpClientBuilder = new HttpClientBuilder(config.funnelBuilder.apiHost, {
      headers: {
        'api-key': config.funnelBuilder.apiKey,
      },
      timeout: config.funnelBuilder.requestTimeout,
    }).addRequestId();

    if (shouldRetry) {
      httpClientBuilder.addRetry(loggingService, config);
    }

    const httpClient = httpClientBuilder.getResult();

    return new HttpFunnelService(httpClient, loggingService, config);
  }
}
